import PropTypes from 'prop-types';
import { Stack } from '@openedx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from '@src/courseware/course/sequence/messages';
import { BookmarkButton } from '@src/courseware/course/bookmark';

import UnitTranslationSelector from './translation-button';

const LegacyUnitTitle = ({
  dispatch,
  id,
  unitId,
  unit,
}) => {
  const { formatMessage } = useIntl();
  const isProcessing = unit.bookmarkedUpdateState === 'loading';

  return (
    <Stack>
      <div>
        <h3 className="h3">{unit.title}</h3>
        <p className="sr-only">{formatMessage(messages.headerPlaceholder)}</p>
      </div>
      <UnitTranslationSelector
        {...{
          id,
          unitId,
          unitTitle: unit.title,
          dispatch,
          isLegacyButton: true,
        }}
      />
      <div className="float-left">
        <BookmarkButton
          unitId={unit.id}
          isBookmarked={unit.bookmarked}
          isProcessing={isProcessing}
          dispatch={dispatch}
        />
      </div>
    </Stack>
  );
};

LegacyUnitTitle.propTypes = {
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  unitId: PropTypes.string.isRequired,
  unit: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    bookmarked: PropTypes.bool.isRequired,
    bookmarkedUpdateState: PropTypes.string,
  }).isRequired,
};

export default LegacyUnitTitle;
